import React from "react";

const NetherlandReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for Netherlands:</h3>
        <p>
          The validation for Netherlands has its own importance in the visa
          procedure & growth of the business in Netherlands. Apostille is
          required as Netherlands is a part of the Hague Convention. There are
          policies of Netherlands that require documents with MEA sticker to
          permit a visitor to enter their nation. It is a part of safety in
          order to show the trustworthiness of the documents. Therefore, the
          legalization of documents becomes an essential for these reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille:</h3>
        <p>
          The overall time period needed for Netherlands Apostille is based on
          various aspects such as which state the certificate was issued from,
          or the kinds of documents, or the authority you require it from.
          Generally, it will take around couple of weeks to 2-3 working days to
          accomplish Apostille services in Bangalore for Netherlands.
        </p>
      </div>
    </div>
  );
};

export default NetherlandReqMain;
